import React from 'react';
import { Input } from '@hub/input';
import { useToken } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";

const CentreSearchBar = _ref => {
  let {
    onChange
  } = _ref;
  const smoke = useToken('colors', 'smoke');
  return /*#__PURE__*/_jsx(Input, {
    backgroundColor: smoke,
    border: "0 px",
    placeholder: "Search by centre name",
    onChange: e => {
      onChange(e.target.value);
    },
    "data-id": "hamburger-menu_centre-search-bar_CentreSearchBar_Input"
  });
};

export default CentreSearchBar;